import type { AlertOptions } from '@flash-global66/g-dialog-alert';
import type { KycCompliance } from '@/types/KycCompliance';

export const alertIncompleteOnboarding: AlertOptions = {
  type: 'important',
  title: 'Esta función no se encuentra disponible por el momento',
  description:
    'Completa el proceso de registro de tu empresa y su posterior validación para obtener acceso completo.',
  primaryText: 'Entendido',
  secondaryText: 'Agenda una reunión',
};

export const alertPendingOnboarding: AlertOptions = {
  type: 'info',
  title: 'Aún no puedes usar esta función',
  description:
    'La validación de tus documentos para completar tu registro en Global66 está en curso. Te avisaremos cuando haya finalizado.',
  primaryText: 'Entendido',
  secondaryText: 'Agenda una reunión',
};

function openExternalUrl(url: string): void {
  window.open(url, '_blank');
}

/**
 * Resuelve el botón elegido en las alertas de onboarding.
 * Con `secondary` abre el calendario de reuniones según el país de la empresa (CO u otro).
 *
 * @returns `true` solo si se pulsó el botón primario
 */
export function onButtonAlertOnb(
  kycStore: KycCompliance | null | undefined,
  primary?: boolean,
  secondary?: boolean
): boolean {
  if (primary) {
    return true;
  }

  if (secondary) {
    if (kycStore?.company?.addressCountry?.country === 'CO') {
      openExternalUrl('https://calendly.com/site-colombia');
    } else {
      openExternalUrl('https://calendly.com/crea-tu-cuenta-global-empresarial');
    }
  }

  return false;
}
